import React from "react";
import InfoIcon from "@mui/icons-material/Info";

import { useNavigate } from "react-router-dom";
import CustomBtn from "./ButtonTemplate";

interface GameInfoBtnProps {
  gameId: string;
}

function GameInfoBtn({ gameId }: GameInfoBtnProps) {
  const navigate = useNavigate();

  return (
    <CustomBtn
      action={() => {
        navigate(`/games/${gameId}`);
      }}
      type="info"
      icon={<InfoIcon />}
      tip="Game Details"
    />
  );
}

export default GameInfoBtn;
